import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { MenuIcon } from './icon/menu-icon';
import { LangLink } from './lang-link';
import { LanguageSwitcher } from './language-switcher';
import { useLocalize } from './localize-context';
import { NavLink } from './nav-link';

export const Header = ({ onToggleSidebar }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const localize = useLocalize();

  return (
    <header className="bg-blue-500 text-gray-100 shadow-md static sm:fixed top-0 left-0 right-0 z-30">
      <div className="mx-auto max-w-6xl py-2 px-3 sm:px-6 flex justify-between items-center">
        <button
          className="block rounded-full sm:hidden p-2 xs:mr-2 focus:outline-none focus:shadow-outline-blue"
          onClick={onToggleSidebar}
        >
          <MenuIcon />
          <span className="sr-only">{localize('Menu')}</span>
        </button>
        <div className="text-xl sm:text-2xl flex-none xs:pr-6">
          <LangLink to="/">{localize(data.site.siteMetadata.title)}</LangLink>
        </div>
        <nav className="flex-1">
          <ul className="flex justify-end flex-wrap">
            <li className="mr-4 hidden sm:block">
              <NavLink to="/package">{localize('Packages')}</NavLink>
            </li>
            <li className="mr-4 hidden sm:block">
              <NavLink to="/combo">{localize('Combo')}</NavLink>
            </li>
            <li className="mr-4 hidden sm:block">
              <NavLink to="/itinerary">{localize('Itinerary')}</NavLink>
            </li>
            <li className="mr-4 hidden sm:block">
              <NavLink to="/rate">{localize('Rates')}</NavLink>
            </li>
            <li className="mr-4 hidden sm:block">
              <NavLink to="/reminder">{localize('Reminders')}</NavLink>
            </li>
            <li className="mr-4 hidden sm:block">
              <NavLink to="/album">{localize('Album')}</NavLink>
            </li>
          </ul>
        </nav>
        <div className="xs:ml-4">
          <small>
            <LanguageSwitcher className="p-3 rounded-md" />
          </small>
        </div>
      </div>
    </header>
  );
};
